import { Preferences } from "@capacitor/preferences";
import goTo from "./goTo";
import { Capacitor } from "@capacitor/core";
import { FirebaseAuthentication } from "@capacitor-firebase/authentication";

async function logout() {
  await Preferences.clear();

  const platform = Capacitor.getPlatform();

  if (platform === "android" || platform === "ios") {
    await FirebaseAuthentication.signOut();
  }

  //Removes cache and

  // window.location = window.location.origin;

  window.setTimeout(() => {
    goTo("/")();
    window.doInitialLoad();
  }, 300);

  // window.setTimeout(() => {
  //   goTo("/")();
  // }, 500);

  // serverLine.delete("/cookie").then(() => {
  // window.location = window.location.origin;
  // });
}

export default logout;
